import getIn from 'transmute/getIn';
export const getTicketFromQueryResponse = getIn(['crmObject', 'associations', 'conversationToTicketV2', 'edges', 0, 'node']);